/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Characters(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5002 6.74999C13.8802 6.75012 15.1717 7.44396 16.3645 8.63671C16.6568 8.92958 16.657 9.40452 16.3645 9.69726C16.0717 9.98998 15.5969 9.98963 15.3039 9.69726C14.5286 8.92193 13.8078 8.49424 13.1399 8.33007L12.4172 13.3848V17.5C12.417 17.9139 12.0811 18.2498 11.6672 18.25C11.2531 18.25 10.9174 17.9141 10.9172 17.5V14.084H9.08419V17.5C9.08402 17.9138 8.74797 18.2496 8.33419 18.25C7.92009 18.25 7.58437 17.9141 7.58419 17.5V13.3906L6.86056 8.32909C6.19265 8.49325 5.47281 8.92193 4.69747 9.69726C4.4047 9.99003 3.92985 9.9898 3.63693 9.69726C3.34403 9.40436 3.34403 8.9296 3.63693 8.63671C4.82968 7.44396 6.12016 6.7501 7.50021 6.74999H12.5002ZM8.98458 12.584H11.0168L11.636 8.24999H8.36544L8.98458 12.584ZM10.0002 0.916984C10.641 0.917085 11.2561 1.17187 11.7092 1.62499C12.1622 2.07817 12.4172 2.6932 12.4172 3.33398C12.417 3.97467 12.1622 4.5899 11.7092 5.04296C11.2561 5.49588 10.6409 5.74989 10.0002 5.74999C9.35955 5.74991 8.74433 5.49587 8.29122 5.04296C7.83816 4.5899 7.58436 3.97468 7.58419 3.33398C7.58419 2.69319 7.83821 2.07817 8.29122 1.62499C8.74436 1.17187 9.3594 0.91707 10.0002 0.916984ZM10.0002 2.41698C9.7573 2.41707 9.52456 2.51383 9.35275 2.68554C9.18084 2.85745 9.08419 3.09086 9.08419 3.33398C9.08436 3.57686 9.18099 3.80968 9.35275 3.98144C9.52454 4.15305 9.75738 4.24991 10.0002 4.24999C10.2432 4.24989 10.4768 4.15326 10.6486 3.98144C10.8203 3.8097 10.917 3.57677 10.9172 3.33398C10.9172 3.09103 10.8203 2.85741 10.6486 2.68554C10.4768 2.51372 10.2432 2.41709 10.0002 2.41698Z"
        fill="#35424F"
      />
    </svg>
  )
}

Characters.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Characters
